import {
  PlayerImage,
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import { CloseIconButton } from '@library/components/buttons';
import type { FormattedUser } from '@library/types/user';
import { StatusIndicator } from '@library/components/StatusIndicator';
import { UserKebabMenu } from '@library/components/menus/kebabMenu/UserKebabMenu';
import { formatUserDetails } from '@bo-utils/user';

export interface EditUserHeaderProps {
  user: FormattedUser;
  onClose: () => void;
  onDeactivateUser: (userId: string) => void;
}

export const EditUserHeader = ({
  user,
  onClose,
  onDeactivateUser
}: EditUserHeaderProps) => {
  const { avatar, email, id, initials, name, status } = formatUserDetails(user);

  return (
    <PlayerProfile
      className="border-soFresh-140 flex h-16 flex-1 items-center gap-4 border-b border-solid p-3"
      name={name}
      imageUrl={avatar}
      subheader={email}
    >
      {avatar ? (
        <PlayerImage className="bg-soFresh-120 size-10 rounded-lg" />
      ) : (
        <div className="bg-stankonia-100 text-soClean-100 flex size-10 min-w-[40px] items-center justify-center rounded-lg">
          <span className="text-xl uppercase antialiased">{initials}</span>
        </div>
      )}
      <div className="flex max-w-[205px] flex-col">
        <PlayerName className="font-heebo text-soClean-100 block truncate text-sm font-medium tracking-tight" />
        <PlayerSubheader className="text-soClean-170 font-heebo block truncate text-xs font-medium tracking-tight" />
      </div>
      <div className="text-soClean-110 flex flex-1 justify-end p-3 pr-1.5 text-xs capitalize">
        <StatusIndicator className="self-center" status={status} />
        <p className="pl-2">{status}</p>
      </div>
      <div className="flex">
        <UserKebabMenu
          menuActions={{ onDelete: onDeactivateUser }}
          menuItemsClassName="!top-7 !bottom-auto !right-0"
          id={id}
        />
      </div>
      <CloseIconButton handleOnClick={onClose} />
    </PlayerProfile>
  );
};
